export default __webpack_public_path__ + "assets/img/by.4c57e6c.svg";